<template>
    <v-container class="mt-12 pt-8" style="background:#fafafa;">
        <!-- Title and Introduction -->
        <v-row>
            <v-col cols="12" class="text-center mb-4">
                <h2 class="text-h4 font-weight-bold mb-2">{{ i18n['integration_reset_title'] || "Reset Integration IDs" }}</h2>
                <p class="text-subtitle-1">{{ i18n['integration_reset_subtitle'] || "Upload an Excel file containing lead keys to reset their integration_sent_id values" }}</p>
            </v-col>
        </v-row>
    <!-- File Upload Section -->
    <v-row class="align-center justify-center mb-6">
        <v-col cols="12" md="6" class="text-center">
            <v-card class="pa-4" outlined>
                <v-card-title class="justify-center">{{ i18n['upload_excel'] || "Upload Excel File" }}</v-card-title>
                <v-card-text>
                    <v-file-input
                        v-model="excelFile"
                        :label="i18n['select_file'] || 'Select Excel file'"
                        outlined
                        dense
                        accept=".xlsx, .xls, .csv"
                        prepend-icon="mdi-file-excel"
                        :class="localizedClass()"
                        show-size
                        :error-messages="fileErrors"
                        @change="clearFileError"
                    ></v-file-input>
                    
                    <p class="text-caption mt-2">
                        {{ i18n['file_format_tip'] || "File must contain a column named 'key' with the lead keys" }}
                    </p>
                    
                    <v-btn 
                        color="primary" 
                        block 
                        class="mt-4" 
                        :loading="uploading" 
                        :disabled="!excelFile" 
                        @click="uploadExcelFile"
                    >
                        {{ i18n['reset_integration_ids'] || "Reset Integration IDs" }}
                        <v-icon right>mdi-upload</v-icon>
                    </v-btn>
                </v-card-text>
            </v-card>
        </v-col>
    </v-row>

    <!-- Results/Feedback Section -->
    <v-row v-if="showResults" class="justify-center">
        <v-col cols="12" md="8">
            <v-alert 
                :type="resultSuccess ? 'success' : 'error'" 
                border="left" 
                colored-border 
                elevation="2"
                dismissible
                @input="showResults = $event"
            >
                <h3 class="text-h6 mb-2">{{ resultSuccess ? (i18n['success'] || "Success!") : (i18n['error'] || "Error!") }}</h3>
                <p>{{ resultMessage }}</p>
                
                <div v-if="resultSuccess" class="mt-3">
                    <v-divider class="my-3"></v-divider>
                    <strong>{{ i18n['summary'] || "Summary" }}:</strong>
                    <ul class="mt-2">
                        <li>{{ i18n['total_keys_found'] || "Total keys found" }}: {{ resultData.total_keys || 0 }}</li>
                        <li>{{ i18n['records_updated'] || "Records updated" }}: {{ resultData.updated_records || 0 }}</li>
                    </ul>
                </div>
            </v-alert>
        </v-col>
    </v-row>

    <!-- Recent Activity Table -->

</v-container>
</template>
<script>
import axios from 'axios';

export default {
    data() {
        return {
            // File upload related
            excelFile: null,
            fileErrors: [],
            uploading: false,
            
            // Results display
            showResults: false,
            resultSuccess: false,
            resultMessage: '',
            resultData: {},
            
            // Recent activity
            showRecentActivity: true,
            loadingActivity: false,
            search: '',
            recentActivity: [],
            activityHeaders: [
                { 
                    text: this.$store.state.i18n[this.$store.state.language]['date'] || 'Date & Time', 
                    value: 'timestamp',
                    align: this.$store.state.language === 'ar' ? 'end' : 'start'
                },
                { 
                    text: this.$store.state.i18n[this.$store.state.language]['user'] || 'User', 
                    value: 'user',
                    align: this.$store.state.language === 'ar' ? 'end' : 'start'
                },
                { 
                    text: this.$store.state.i18n[this.$store.state.language]['action'] || 'Action', 
                    value: 'action',
                    align: this.$store.state.language === 'ar' ? 'end' : 'start'
                },
                { 
                    text: this.$store.state.i18n[this.$store.state.language]['records'] || 'Records', 
                    value: 'records',
                    align: this.$store.state.language === 'ar' ? 'end' : 'start'
                },
                { 
                    text: this.$store.state.i18n[this.$store.state.language]['status'] || 'Status', 
                    value: 'status',
                    align: this.$store.state.language === 'ar' ? 'end' : 'start'
                }
            ]
        };
    },
    
    computed: {
        i18n() {
            return this.$store.state.i18n[this.$store.state.language];
        },
        arabic() {
            return this.$store.state.language === 'ar';
        },
    },
    
    mounted() {
        // this.fetchRecentActivity();
    },
    
    methods: {
        localizedClass(baseClass = '') {
            return `${this.arabic ? 'arFont' : 'enFont'} ${baseClass}`;
        },
        
        clearFileError() {
            this.fileErrors = [];
        },
        
        async uploadExcelFile() {
            if (!this.excelFile || !(this.excelFile instanceof File)) {
  this.fileErrors = ['Invalid or missing file'];
  return;
}

  const formData = new FormData();
  formData.append('file', this.excelFile);

  this.uploading = true;
  let response = null;

try {
  response = await this.$store.dispatch('postFileResource', {
    resource: '/admin/reset-integration-sentid',
    fileData: formData
  });

  if (response && response.success) {
    this.resultSuccess = true;
    this.resultMessage = response.message;
    this.resultData = response.data || {};
    this.excelFile = null;
  } else {
    this.resultSuccess = false;
    this.resultMessage = (response && response.message) ? response.message : 'Unknown response error';
}

} catch (error) {
  console.error('❌ File upload failed:', error);

  this.resultSuccess = false;
  this.resultMessage =
    error && error.response && error.response.data && error.response.data.message
      ? error.response.data.message
      : 'File upload error';

  this.fileErrors =
    error && error.response && error.response.data &&
    error.response.data.errors && error.response.data.errors.file
      ? error.response.data.errors.file
      : [];
}
finally {
  this.showResults = true;
  this.uploading = false;
}

},

        
        // async fetchRecentActivity() {
        //     this.loadingActivity = true;
            
        //     try {
        //         const response = await this.$store.dispatch('getResource', {
        //             resource: '/integration-activity'
        //         });
                
        //         if (response && Array.isArray(response)) {
        //             this.recentActivity = response;
        //         } else {
        //             // Sample data in case the API doesn't exist yet
        //             this.recentActivity = [
        //                 {
        //                     timestamp: new Date(),
        //                     user: 'Admin User',
        //                     action: 'Reset Integration IDs',
        //                     records: 50,
        //                     status: 'success'
        //                 }
        //             ];
        //         }
                
        //     } catch (error) {
        //         console.error('Error fetching activity:', error);
        //         // Add sample data for UI demonstration
        //         this.recentActivity = [
        //             {
        //                 timestamp: new Date(),
        //                 user: 'Admin User',
        //                 action: 'Reset Integration IDs',
        //                 records: 50,
        //                 status: 'success'
        //             }
        //         ];
        //     } finally {
        //         this.loadingActivity = false;
        //     }
        // },
        
        formatDateTime(dateString) {
            const date = new Date(dateString);
            const formattedDate = date.toISOString().split('T')[0];
            let hours = date.getHours();
            const minutes = date.getMinutes().toString().padStart(2, '0');
            const ampm = hours >= 12 ? 'PM' : 'AM';
            hours = hours % 12 || 12;
            return `${formattedDate} ${hours}:${minutes} ${ampm}`;
        }
    }
};
</script>
<style scoped>
.v-card {
    transition: all 0.3s;
}
.v-card:hover {
    transform: translateY(-3px);
    box-shadow: 0 4px 8px rgba(0,0,0,0.1);
}

.arFont {
    font-family: 'Cairo', sans-serif !important;
    text-align: right;
}

.enFont {
    font-family: 'Roboto', sans-serif !important;
    text-align: left;
}
</style>